import { Reducer } from "redux";
import { PushBreadcrumbProviderAction, PopBreadcrumbProviderAction, ResetBreadcrumbsProvidersAction, POP_BREADCRUMB_PROVIDER, PUSH_BREADCRUMB_PROVIDER, RESET_BREADCRUMBS_PROVIDERS, RESTORE_BREADCRUMBS_PROVIDERS, RestoreBreadcrumbsProvidersAction } from "@/actions/breadcrumbProvider";
import { BreadcrumbItemProvider } from "@/types/resource";

type ActionTypes =
  | PushBreadcrumbProviderAction
  | PopBreadcrumbProviderAction
  | ResetBreadcrumbsProvidersAction
  | RestoreBreadcrumbsProvidersAction
  ;


export const breadcrumbProviderReducer: Reducer<BreadcrumbItemProvider[], ActionTypes> = (
  previousState = [],
  action
) => {
  switch (action.type) {
    case PUSH_BREADCRUMB_PROVIDER: {
      const i = previousState.findIndex(p => p.pathname === action.payload.pathname)
      if (i > -1) {
        return [...previousState.slice(0, i), action.payload]
      } else {
        return [...previousState, action.payload]
      }
    }
    case POP_BREADCRUMB_PROVIDER: {
      if (previousState.length === 0) {
        return previousState
      }
      const tail = previousState[previousState.length - 1]
      return (tail.pathname === action.pathname
        ? previousState.slice(0, previousState.length - 2)
        : previousState)
    }
    case RESET_BREADCRUMBS_PROVIDERS: {
      window.sessionStorage.removeItem(c_key)
      return previousState.length === 0 ? previousState : []
    }
    case RESTORE_BREADCRUMBS_PROVIDERS: {
      if (previousState.length > 0) { return previousState }
      
      const s1 = readBreadcrumbFromSessionStorage()
      return s1.length > 0 ? s1 : previousState
    }
    default: return previousState
  }
}

export const getBreadcrumbProviders = (state:any): BreadcrumbItemProvider[]|undefined =>
  state.od.breadcrumbProvider ?? undefined;

const c_key = 'od_extra_bc'

export const readBreadcrumbFromSessionStorage = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(c_key) ?? '[]') as BreadcrumbItemProvider[]
  } catch {
    return []    
  }
}
